import { Service } from './Service';
export class DummyService extends Service {
  constructor(uid) {
    super();
    this.uid = uid;
  }
}